import { easepick, RangePlugin, LockPlugin } from '@easepick/bundle';

export const popupBookRooms = () => {

	const picker = new easepick.create({
	    element: "#rooms-date",
	    plugins: [
	        RangePlugin,
	        LockPlugin
	    ],
	    css: [
	        "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css"
	    ],
	    zIndex: 10,
	    LockPlugin: {
	        minDate: new Date()
	    }
	})



	let submitRoomsBookingForm = document.querySelector('.js__submit-rooms-reservations');

	if(submitRoomsBookingForm){

		submitRoomsBookingForm.addEventListener('click', (e) => {
			e.preventDefault();

			let bookingEndpoint = document.querySelector('#booking-endpoint').value,
				bookingDates 	= document.querySelector('#rooms-date').value.split(' - '),
				bookingAdults	= document.querySelector('#num-adults').value,
				bookingChildren = document.querySelector('#num-children').value;

			window.open(bookingEndpoint + '?locale=en&items[0][adults]='+bookingAdults+'&items[0][children]='+bookingChildren+'&items[0][infants]=0&checkInDate='+bookingDates[0]+'&checkOutDate='+bookingDates[1]+'&currency=GBP', "_blank");

		})

	}

}